import { Horizontal, MomentDatePicker, Texto } from '@gravitate-js/excalibrr'
import { DatePicker, Form, type FormInstance, Switch } from 'antd'
import moment from 'moment'
import React from 'react'

import type { OutageForm } from '../types'
import { WeekdaySelectOptions } from './WeekdaySelectOptions'

type RecurringScheduleInputsProps = {
  form: FormInstance<OutageForm>
}
export function RecurringScheduleInputs({ form }: RecurringScheduleInputsProps) {
  return (
    <div>
      <Form.Item noStyle dependencies={[['schedule_local', 'isForever']]}>
        {({ getFieldValue }) => {
          const isForever = getFieldValue(['schedule_local', 'isForever'])
          return (
            <Horizontal verticalCenter>
              <Form.Item
                label='Start Date'
                name={['schedule_local', 'start_date']}
                rules={[{ required: true, message: 'Select Start Date' }]}
              >
                <MomentDatePicker
                  format='MM/DD/yyyy'
                  disabledDate={(current) => current && current < moment().startOf('day')}
                />
              </Form.Item>
              <Form.Item
                label='End Date'
                name={['schedule_local', 'end_date']}
                className='ml-4'
                rules={[{ required: !isForever, message: 'Select End Date' }]}
              >
                <MomentDatePicker
                  format='MM/DD/yyyy'
                  disabledDate={(current) => current && current < moment().startOf('day')}
                  disabled={isForever}
                />
              </Form.Item>
              <Texto className='mr-1 ml-4'>Forever</Texto>
              <Form.Item
                name={['schedule_local', 'isForever']}
                valuePropName='checked'
                style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}
              >
                <Switch />
              </Form.Item>
            </Horizontal>
          )
        }}
      </Form.Item>
      <WeekdaySelectOptions form={form} />
    </div>
  )
}
